// extracted by mini-css-extract-plugin
export default {"gradientScrollDiv":"InvoiceList-module__gradientScrollDiv_YCaVB","invoiceListContainer":"InvoiceList-module__invoiceListContainer_yZ5CF"};